import React from 'react';
import { Link } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface TrialRunUsedPanelProps {
  workflowName: string;
  message?: string;
}

const TrialRunUsedPanel: React.FC<TrialRunUsedPanelProps> = ({
  workflowName,
  message,
}) => (
  <div className='trial-run-used-panel'>
    <div className='trial-run-used-icon-tile'>
      <LockOutlinedIcon className='trial-run-used-icon' />
    </div>
    <div className='trial-run-used-copy'>
      <div className='trial-run-used-eyebrow'>Trial run used</div>
      <h3 className='trial-run-used-headline'>
        You&rsquo;ve used your free {workflowName} run
      </h3>
      <p className='trial-run-used-body'>
        {message ||
          `Your team's one trial run of the ${workflowName} has been used. Upgrade your plan to keep using ${workflowName}.`}
      </p>
    </div>
    <Link
      className='btn-primary trial-run-used-cta'
      to={{
        pathname: '/profile',
        state: {
          linkTab: 'Subscriptions',
        },
      }}
    >
      Upgrade plan <ArrowForwardIcon fontSize='small' />
    </Link>
  </div>
);

export default TrialRunUsedPanel;
